import { useHistory } from 'react-router-dom';

function PromptOpt(props) {
	// Alternate background color based on row index
	var index = props.index;
	var promptOpt = props.promptOpt;
	const bg = index % 2 === 0 ? "bg-[rgba(49,169,255,0.2)]" : "bg-[rgba(101,191,255,0.5)]";
	let history = useHistory();

	return (
		<button
			key={"promptOpt" + index}
			className={`${bg} cursor-pointer h-[35px] relative shrink-0 w-full`}
			onClick={() => {
				history.push({
					pathname: "/PromptOpt/" + promptOpt.id.toString(),
					promptOpt: promptOpt
				})
			}}
		>
			<div
				aria-hidden="true"
				className="absolute border border-[rgba(0,0,0,0.7)] border-solid inset-0 pointer-events-none"
			/>
			<div className="flex flex-row items-center size-full">
				<div className="box-border content-stretch flex font-['Inter:Medium',sans-serif] font-medium h-[35px] items-center leading-[0] not-italic px-[10px] py-[6px] relative text-[16px] tracking-[-0.08px] w-full">
					<div className="basis-0 flex flex-col grow justify-center min-h-px min-w-px relative shrink-0">
						<p className="leading-[1.45] text-left">{promptOpt.emailVerzender}</p>
					</div>
					<div className="basis-0 flex flex-col grow justify-center min-h-px min-w-px relative shrink-0">
						<p className="leading-[1.45] text-left">{promptOpt.emailOntvanger}</p>
					</div>
				</div>
			</div>
		</button>
	);
} export default PromptOpt